import React from 'react';
import PropTypes from 'prop-types';

import { SuiContainer, SuiButton } from '@splashthat/sui';
import CubeLoaderOverlay from 'common/components/CubeLoaderOverlay';
import { MODAL_SIZE } from 'common/components/CubeLoader';
import { colorAppContainerBackground } from 'common/styles/colors';
import ImageCrop from 'common/components/ImageCrop';

import SplashCakeClient from 'lib/SplashCakeClient';

import './styles.styl';

const baseClassName = 'ImageCropper';

export default class ImageCropper extends React.Component {
    static propTypes = {
        onCrop: PropTypes.func.isRequired,
        onCropError: PropTypes.func.isRequired,
        onCropSelected: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
        imageUrl: PropTypes.string.isRequired,
        suiContainerVariation: PropTypes.string,
        initialCrop: PropTypes.object,
        handleCropping: PropTypes.bool.isRequired,
        keepOpenWhileCropping: PropTypes.bool.isRequired,
    };
    static defaultProps = {
        suiContainerVariation: 'flex-center',
        initialCrop: undefined,
    };

    constructor(...args) {
        super(...args);

        this.cake = new SplashCakeClient();

        this.state = {
            isCropping: false,
        };
    }

    handleClickCrop = (event) => {
        this.props.onCropSelected(this.imageCropRef.getCrop());

        if (this.props.handleCropping) {
            this.crop();
        }
    };

    handleClickCancel = () => {
        this.props.onCancel();
    };

    setImageCropRef = (ref) => {
        this.imageCropRef = ref;
    };

    crop() {
        if (this.state.isCropping) {
            return;
        }

        const { onCrop, onCropError } = this.props;

        const crop = this.imageCropRef.getCrop();
        if (!crop) {
            onCrop(null, this.props.imageUrl);
            return;
        }

        if (this.props.keepOpenWhileCropping) {
            this.setState({ isCropping: true });
        }

        const params = {
            x: crop.x,
            y: crop.y,
            w: crop.width,
            h: crop.height,
            percentage: 1,
        };

        this.cake
            .cropImage(this.props.imageUrl, params)
            .then((response) => {
                if (this.props.keepOpenWhileCropping) {
                    this.setState({ isCropping: false });
                }

                onCrop(crop, response.new_src);
            })
            .catch((...args) => {
                onCropError(...args);
            });
    }

    render() {
        const { imageUrl, initialCrop, suiContainerVariation } = this.props;

        const { isCropping } = this.state;

        return (
            <SuiContainer variation={suiContainerVariation}>
                <SuiContainer>
                    <ImageCrop
                        ref={this.setImageCropRef}
                        className={`${baseClassName}_image-crop`}
                        initialCrop={initialCrop}
                        src={imageUrl}
                    />
                    <CubeLoaderOverlay
                        loading={isCropping}
                        size={MODAL_SIZE}
                        backgroundColor={colorAppContainerBackground}
                    />
                </SuiContainer>

                <SuiContainer variation="flex-horizontal padded">
                    <SuiContainer variation="flex-group">
                        <SuiButton
                            label="Cancel"
                            variation="secondary"
                            onClick={this.handleClickCancel}
                            disabled={isCropping}
                        />
                    </SuiContainer>
                    <SuiContainer variation="flex-group">
                        <SuiButton label="Crop" onClick={this.handleClickCrop} disabled={isCropping} />
                    </SuiContainer>
                </SuiContainer>
            </SuiContainer>
        );
    }
}
